import {
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_FAIL,
  ADMIN_LOGOUT,
  GET_ADMINS_REQUEST,
  GET_ADMINS_SUCCESS,
  GET_ADMINS_FAIL,
  GET_ADMINS_RESET,
  ADD_ADMIN_REQUEST,
  ADD_ADMIN_SUCCESS,
  ADD_ADMIN_FAIL,
  ADD_ADMIN_RESET,
  UPDATE_ADMIN_REQUEST,
  UPDATE_ADMIN_SUCCESS,
  UPDATE_ADMIN_FAIL,
  UPDATE_ADMIN_RESET,
  NEW_PASSWORD_ADMIN_REQUEST,
  NEW_PASSWORD_ADMIN_SUCCESS,
  NEW_PASSWORD_ADMIN_FAIL,
  NEW_PASSWORD_ADMIN_RESET,
} from '../constants/adminConstants'

export const adminLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case ADMIN_LOGIN_REQUEST:
      return { loadingAdminInfo: true }
    case ADMIN_LOGIN_SUCCESS:
      return { loadingAdminInfo: false, adminInfo: action.payload }
    case ADMIN_LOGIN_FAIL:
      return { loadingAdminInfo: false, errorAdminInfo: action.payload }
    case ADMIN_LOGOUT:
      return {}
    default:
      return state
  }
}

export const getAdminsReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_ADMINS_REQUEST:
      return { loadingGetAdmins: true }
    case GET_ADMINS_SUCCESS:
      return { loadingGetAdmins: false, getAdminsData: action.payload }
    case GET_ADMINS_FAIL:
      return { loadingGetAdmins: false, errorGetAdmins: action.payload }
    case GET_ADMINS_RESET:
      return {}
    default:
      return state
  }
}

export const addAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_ADMIN_REQUEST:
      return { loadingAddAdmin: true }
    case ADD_ADMIN_SUCCESS:
      return { loadingAddAdmin: false, addAdminData: action.payload }
    case ADD_ADMIN_FAIL:
      return { loadingAddAdmin: false, errorAddAdmin: action.payload }
    case ADD_ADMIN_RESET:
      return {}
    default:
      return state
  }
}

export const updateAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_ADMIN_REQUEST:
      return { loadingUpdateAdmin: true }
    case UPDATE_ADMIN_SUCCESS:
      return { loadingUpdateAdmin: false, updateAdminData: action.payload }
    case UPDATE_ADMIN_FAIL:
      return { loadingUpdateAdmin: false, errorUpdateAdmin: action.payload }
    case UPDATE_ADMIN_RESET:
      return {}
    default:
      return state
  }
}

export const newPasswordAdminReducer = (state = {}, action) => {
  switch (action.type) {
    case NEW_PASSWORD_ADMIN_REQUEST:
      return { loadingNewPasswordAdmin: true }
    case NEW_PASSWORD_ADMIN_SUCCESS:
      return {
        loadingNewPasswordAdmin: false,
        newPasswordAdminData: action.payload,
      }
    case NEW_PASSWORD_ADMIN_FAIL:
      return {
        loadingNewPasswordAdmin: false,
        errorNewPasswordAdmin: action.payload,
      }
    case NEW_PASSWORD_ADMIN_RESET:
      return {}
    default:
      return state
  }
}
